import { CardContent } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const WidgetBody = styled(CardContent) `
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
